module.exports = fox => ({
	formInvalidate(infos, form) {
		return infos.forEach(info => {
			const { result, field, message } = info;
			const element = form.getElement(field);
			const [node] = element.nodes;
			const container = node.parentNode;
			const error = container.nextSibling;
			const removeError = () => {
				fox.dom.removeClass('error', container);

				if (error) {
					error.innerText = '';
					error.style.display = 'none';
				}
			}

			if (!result) {
				fox.dom.addClass('error', container);

				if (error) {
					error.innerText = message || 'Cannot be empty';
					error.style.display = 'inherit';
				}

				const handler = () => {
					fox.dom.off('focus', node, handler);

					removeError();
				}

				fox.dom.on('focus', node, handler);
			} else {
				removeError();
			}
		});
	}
});


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/common/widget/mixin/formvalidation.es.js